import { getTimezonesApiCall } from '@guryou/api-client-gql';
import { execute } from './actionWrapper';
import { Action } from '../core';
export const GET_ALL_TIMEZONES = {
  entity: 'GET_ALL_TIMEZONES',
  action: Action.GET_MANY
};
const getTimezones = () => async dispatch => execute(dispatch, () => getTimezonesApiCall(), GET_ALL_TIMEZONES, false, false, null);
export { getTimezones };